var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable no-underscore-dangle */
import React, { forwardRef } from 'react';
import { useFormikContext } from 'formik';
export const Form = forwardRef((props, ref) => {
    const { action, autoComplete, method } = props, rest = __rest(props, ["action", "autoComplete", "method"]);
    const { handleReset, handleSubmit, isSubmitting } = useFormikContext();
    /**
     * We default the action to "#" in case the preventDefault fails (just updates the URL hash)
     *
     * iOS needs an "action" attribute for nice input…
     * @see https://stackoverflow.com/a/39485162/406725
     */
    const _action = action || '#';
    const _method = method || 'post';
    /**
     * We want take advantage of autofill by default, so that users can easily complete forms with pre-populated data.
     * In the rare case that this needs to be disabled, simply pass `autoComplete="off"`.
     *
     * For more information on field level autocomplete values…
     * @see https://developers.google.com/web/fundamentals/design-and-ux/input/forms#use_metadata_to_enable_auto-complete
     *
     * For more information on disabling, form autocompletion…
     * @see https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
     * */
    const _autoComplete = autoComplete || 'on';
    const _onSubmit = (e) => {
        if (isSubmitting) {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            return;
        }
        handleSubmit(e);
    };
    return (React.createElement("form", Object.assign({ method: _method, onSubmit: _onSubmit, ref: ref, onReset: handleReset, action: _action, autoComplete: _autoComplete, 
        // HTML5 Validation allows supporting browsers to mark erroneous field or fall back to server-side validation.
        // Unfortunately, this is not implemented uniformly, so we want to disable this by default in favor of our own error handling.
        // SEE: https://caniuse.com/form-validation
        noValidate: true }, rest)));
});
Form.displayName = 'Form';
//# sourceMappingURL=Form.js.map